import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("linearGradient", {
  fill: "currentColor",
  id: "a",
  gradientUnits: "userSpaceOnUse",
  x1: "100",
  y1: "622.859",
  x2: "100",
  y2: "747.145",
  gradientTransform: "translate(0 -567)"
}, [
  /*#__PURE__*/_createElementVNode("stop", {
    fill: "currentColor",
    offset: "0"
  }),
  /*#__PURE__*/_createElementVNode("stop", {
    fill: "currentColor",
    offset: "1"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "m166.4 74 19.8 17.2c3.5 3 4.7 7.8 3 12.1-1.7 4.3-5.8 7-10.5 7h-14.6v52.3c0 9.6-8.1 17.5-17.9 17.5H53.6c-9.9 0-17.9-7.8-17.9-17.5v-52.3H21.9c-5 0-9.3-2.9-11.1-7.4s-.5-9.5 3.1-12.7l76.5-67c2.4-2.1 5.5-3.3 8.8-3.3 3.2 0 6.4 1.2 8.8 3.3l27.1 23.6c.1-4.1 3.6-7.4 7.8-7.4h15.7c4.3 0 7.8 3.4 7.8 7.6v27zm-46.5 48.4c0-3.4-2.8-6.1-6.3-6.1h-9.5v-2.9c9.6-2.3 16.7-10.7 16.7-20.7 0-11.8-9.8-21.4-21.9-21.4-12 0-21.9 9.6-21.9 21.3 0 9.3 6.1 17.2 14.6 20.1V147c0 3.4 2.8 6.1 6.3 6.1s6.3-2.7 6.3-6.1v-1.3h9.5c3.5 0 6.3-2.7 6.3-6.1s-2.8-6.1-6.3-6.1h-9.5v-5.1h9.5c3.4.1 6.2-2.6 6.2-6zM92.3 99.1c-1.8-1.7-2.8-4.1-2.8-6.5s1-4.8 2.8-6.5 4.2-2.7 6.7-2.7 4.9 1 6.7 2.7c1.8 1.7 2.8 4.1 2.8 6.5s-1 4.8-2.8 6.5-4.2 2.7-6.7 2.7c-2.6 0-5-1-6.7-2.7z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "tri-icon",
    style: _normalizeStyle(`font-size: ${_ctx.size}; color: ${_ctx.color}; width: 1em; height: 1em; display:block; line-height: 0;`)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
  ], 4))
}